import React, { useEffect, useState } from "react";
import { api } from "../api";

export default function BugList() {
  const [bugs, setBugs] = useState([]);

  const fetchBugs = async () => {
    try {
      const { data } = await api.get("/bugs");
      setBugs(data);
    } catch (err) {
      console.error("Kunde inte hämta buggar:", err);
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.patch(`/bugs/${id}/status`, { status });
      fetchBugs();
    } catch (err) {
      console.error("Kunde inte uppdatera status:", err);
    }
  };

  useEffect(() => {
    fetchBugs();
  }, []);

  return (
    <div className="container mt-4">
      <h3>Felrapporter</h3>
      <div className="row g-3">
        {bugs.map(bug => (
          <div key={bug._id} className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title">{bug.category}</h5>
                <p className="card-text">{bug.description}</p>

                {bug.imageUrl && (
                  <img src={bug.imageUrl} alt="Bug screenshot" className="img-fluid mb-2" />
                )}

                <p className="text-muted small">
                  Av: {bug.reporterId.firstName} {bug.reporterId.lastName} ({bug.reporterId.role}) <br />
                  {bug.reporterId.email}
                </p>

                <span className={`badge ${bug.status === "Ny" ? "bg-danger" : bug.status === "Bearbetar" ? "bg-warning text-dark" : "bg-success"}`}>
                  {bug.status}
                </span>

                <div className="mt-3 d-flex gap-2">
                  {bug.status !== "Bearbetar" && bug.status !== "Slutförd" && (
                    <button className="btn btn-sm btn-warning" onClick={() => updateStatus(bug._id, "Bearbetar")}>
                      Bearbeta
                    </button>
                  )}
                  {bug.status !== "Slutförd" && (
                    <button className="btn btn-sm btn-success" onClick={() => updateStatus(bug._id, "Slutförd")}>
                      Slutförd
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
        {bugs.length === 0 && <p className="text-muted">Inga buggar rapporterade.</p>}
      </div>
    </div>
  );
}
